const axios = require('axios');

export default {
    install(vue){
        const apiKey = 'beac7c40c6ebee3f7f54a7a3544c9986';

        const checkPositionPerm = () => {
            return Promise.race([
                new Promise(resolve => { if(!navigator.geolocation) resolve('denied'); }),
                new Promise(resolve => navigator.geolocation.getCurrentPosition(() => resolve('granted'), () => resolve('denied'), { timeout: 200 })),
                new Promise(resolve => setTimeout(() => resolve('default'), 199)),
            ])
        }

        const getPosition = () => new Promise(resolve => navigator.geolocation.getCurrentPosition(position => resolve(position), () => resolve(false)));
        const Get = () => vue.$cache.Get('weather_cache', 60*4, async () => {
            const position = await getPosition();

            if (position)
                return new Promise(resolve =>
                    axios.get(`https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=${apiKey}&units=imperial`)
                    .then(response => resolve(response.data)));
            else
                return new Promise(resolve =>
                    axios.get(`https://api.openweathermap.org/data/2.5/weather?zip=10001&appid=${apiKey}&units=imperial`)
                        .then(response => resolve(response.data)));
        })

        vue.prototype.$weather = {
            checkPositionPerm,
            Get
        };
        vue.$weather = {
            checkPositionPerm,
            Get
        };
    }
}